// extracted by mini-css-extract-plugin
export var redoItem = "_ow-1";
export var redoTrigger = "_ow-0";